'use client'

import { CloseButton, Flex, Group, Modal, Stack } from '@mantine/core'
import { REDIRECT_AFTER_LOGIN_COOKIE } from '@partment/types'
import { RiLogoutCircleRLine } from '@remixicon/react'
import { setCookie } from 'cookies-next/client'
import { signOut, useSession } from 'next-auth/react'
import { useTranslations } from 'next-intl'
import { FC, useState } from 'react'
import { Button, Text, Title } from '../..'
import { profileLogout } from '../../api'

import classes from './Logout.module.css'

const LogoutModal: FC<{ opened: boolean; close: () => void }> = ({
  opened,
  close,
}) => {
  const t = useTranslations('Ui.Profile')
  const { data, status } = useSession()
  const [loading, setLoading] = useState(false)

  const handleLogout = async () => {
    const pathname = window.location.pathname || '/global-portal'

    setCookie(REDIRECT_AFTER_LOGIN_COOKIE, pathname, {
      path: '/',
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax',
    })

    setLoading(true)

    try {
      //@ts-ignore
      await profileLogout(data?.refresh_token)
    } catch (err) {
      console.error(err)
    } finally {

      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('userDetail')
      localStorage.removeItem('InviteData')
      localStorage.removeItem('isInvestor')
      localStorage.removeItem('isCoOwner')
      localStorage.removeItem('isLandlord')

      await signOut({ redirect: false }).catch((signOutError) => {
        console.error(signOutError)
      })

      setLoading(false)
      close()
      window.location.replace('/sso/login')
    }
  }

  return (
    <Modal
      opened={opened}
      onClose={close}
      radius='lg'
      centered
      withCloseButton={false}
    >
      <Stack p='lg' gap={0} className={classes.modalWrapper}>
        <Flex justify='space-between'>
          <div className={classes.roundIconWrapper}>
            <RiLogoutCircleRLine size={20} />
          </div>
          <CloseButton onClick={close} />
        </Flex>
        <Title order={6}>{t('logout-modal.title')}</Title>
        <Text size='xs' mt='sm'>
          {t('logout-modal.description')}
        </Text>
        <Group justify='center' mt='md'>
          <Button flex={1} variant='default' onClick={close}>
            {t('cancel')}
          </Button>

          <Button
            flex={1}
            variant='filled'
            onClick={handleLogout}
            bg='var(--mantine-color-Neutral-8)'
            disabled={status === 'loading'}
            loading={loading}
          >
            {t('logout')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}

export default LogoutModal
